<script lang="ts">
    import Subject from "../../application/SyllabusManager/models/Subject.ts";
    import ConditionTab from "./tabs/ConditionTab.svelte";
    import Manager from "../../application/SyllabusManager/models/Manager.ts";
    import SkillTab from "./tabs/SkillTab.svelte";
    import GeneralTab from "./tabs/GeneralTab.svelte";
    import DescriptionTab from "./tabs/DescriptionTab.svelte";
    import TutorTab from "./tabs/TutorTab.svelte";
    import {writable} from "svelte/store";
    import {_} from "svelte-i18n";

    export let subject: Subject;
    export let manager: Manager;
    export let languages;

    $: subjectData = writable(subject);
</script>

<div class="card p-5">
    {#if $languages === 'hu'}
        <div class="title">{$subjectData.nameHu}</div>
    {/if}
    {#if $languages === 'en'}
	<div class="title">{$subjectData.nameEn}</div>
    {/if}
    <div class="subtitle">{$_('subjectCard.code')} : {$subjectData.code.substring(0, $subjectData.code.length-2)}</div>
    <GeneralTab subjectData={$subjectData}/>
    <TutorTab subjectData={$subjectData} manager={manager}/>
    <SkillTab subjectData={$subjectData} manager={manager}/>
    <ConditionTab languages={languages} dividerTitle={$_('subjectCard.preconditions')} manager={manager} subjectArray={$subjectData.preconditions} subjectStore={subjectData}/>
    <ConditionTab languages={languages} dividerTitle={$_('subjectCard.builds')} manager={manager} subjectArray={$subjectData.buildsOns} subjectStore={subjectData}/>
    <DescriptionTab hasDescription={false} languages={languages} subjectData={$subjectData}/>
</div>
